export enum Buttons {
  accept = 'Aceptar',
  cancel = 'Cancelar',
}

export enum Labels {
  addProduct = 'Agregar Producto',
  address = 'Dirección',
  appName = 'Aromas y algo más',
  appNameShort = 'Aromas',
  cart = 'Carrito',
  contactUs = 'Contáctenos',
  currencySign = '₡',
  email = 'Correo',
  logout = 'Cerrar Sesión',
  orders = 'Pedidos',
  phone = 'Teléfono',
  profile = 'Perfil',
  reports = 'Reportes',
  user = 'Usuario',
  users = 'Usuarios',
}

export enum Messages {}

export const copyRight = () =>
  `© ${
    new Date().toISOString().split('-')[0]
  } CopyRight. Todos los derechos reservados Aromas y algo más | CurlycodeCR `;
